var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHouse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M0.5 0.5H17V22.5H0.5z",
    transform: "translate(-988 -424) translate(868 327) translate(120 75) translate(0 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#FFF",
    d: "M12.167 12.5H20.5V22.5H12.167z",
    transform: "translate(-988 -424) translate(868 327) translate(120 75) translate(0 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3 3H4V8H3zM15 15H16V20H15zM3 11H4V16H3zM6 3H7V8H6zM17 15H18V20H17zM6 11H7V16H6zM9 3H10V8H9zM9 11H10V16H9zM12 3H13V8H12zM12 11H13V13H12z",
    transform: "translate(-988 -424) translate(868 327) translate(120 75) translate(0 22)"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/House.2476634d.svg";
export { ForwardRef as ReactComponent };